import { IReponseApiLogin } from '../interfaces/reponse-api-login.interface';

export class SetReponseLoginApp {
    static readonly type = '[Auth] SetReponseLoginApp';

    constructor(public payload: IReponseApiLogin) {}
}
